const CHUNK_RELOAD_KEY = 'chunk-reload';

export function isChunkLoadError(error: unknown): boolean {
  if (!error) {
    return false;
  }

  const message =
    typeof error === 'string'
      ? error
      : error instanceof Error
        ? error.message
        : typeof error === 'object' && 'message' in error
          ? String((error as { message: unknown }).message)
          : '';

  const name =
    error instanceof Error
      ? error.name
      : typeof error === 'object' && error !== null && 'name' in error
        ? String((error as { name: unknown }).name)
        : '';

  return (
    name === 'ChunkLoadError' ||
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    message.includes('Failed to fetch dynamically imported module')
  );
}

export function reloadOnceOnChunkLoadError(): void {
  const reload = () => {
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      return;
    }

    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
  };

  window.addEventListener('error', (event) => {
    if (!isChunkLoadError(event.error ?? event.message)) {
      return;
    }

    reload();
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadError(event.reason)) {
      return;
    }

    reload();
  });

  window.addEventListener('load', () => {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  });
}
